import {useDraggable} from "@dnd-kit/core";
import {CSS} from "@dnd-kit/utilities";

const Draggable = (props) => {
    const { attributes, listeners, setNodeRef, transform} = useDraggable({
        id: props.id,
    });

    const style = transform
    ? {
        transform: CSS.Translate.toString(transform)
      }
    : undefined;

    return(
        <div ref={setNodeRef}
             {...attributes}
             {...listeners}
             style={style}
             className={`${props.type}`}>
            {props.children}
        </div>
    )
};

export default Draggable;